// extracted by mini-css-extract-plugin
export default {"container":"Hr_container__lsMGD"};